// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

vec4 emissiveColor;
if (tpmData.useTpmEmissiveMap){
	emissiveColor = triplanar_mapping( emissiveMap, inverseTransformDirection( normalize( vNormal ), viewMatrix ), vWorldPosition, emissiveTpmScale );
	emissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;
	totalEmissiveRadiance *= emissiveColor.rgb;
	// debugColor = vec4(0.0, 0.0, 1.0, 1.0);
} else {
	emissiveColor = texture2D( emissiveMap, emissiveMapUv );
	emissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;
	totalEmissiveRadiance *= emissiveColor.rgb;
	//debugColor.y = 0.0;
}


`;